import PortalIdParser from 'PortalIdParser';
export const getAppSettingsUrl = ({
  appId,
  portalId,
  path = ''
}) => {
  const normalizedPath = path.replace(/^\//, '');
  return `/integration/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/settings/${appId}${normalizedPath ? `/${normalizedPath}` : ''}`;
};